import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { Select } from 'foundations-components/transitional/components/Select';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useMemo } from 'react';
import { DEFAULT_APP_SORT_FIELD, DEFAULT_APP_SORT_ORDER } from '../constants/sortConstants';
import { getAppSortOptionValue, getAppSortOptions, parseAppSortOptionValue } from '../utils/sortUtils';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const MENU_ITEM_HEIGHT = 40;
const MENU_PADDING_Y = 8;
const SortSelectItem = ({
  children,
  option
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    delay: 200,
    disabled: !option.tooltip,
    placement: "left",
    title: option.tooltip,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
};
export function AppSortDropdown({
  disabled,
  filters,
  onShowPreferredLanguageFirstChange,
  onSortChange
}) {
  const {
    showPreferredLanguageFirst,
    sortField,
    sortOrder
  } = filters;
  const handleChange = event => {
    const eventValue = event.target.value;
    const {
      sortField: field,
      sortOrder: order
    } = parseAppSortOptionValue(eventValue);
    onSortChange(field, order);
  };
  const value = useMemo(() => {
    return getAppSortOptionValue(sortField || DEFAULT_APP_SORT_FIELD, sortOrder || DEFAULT_APP_SORT_ORDER);
  }, [sortField, sortOrder]);
  const options = getAppSortOptions();
  const totalOptions = options.length;
  const minHeight = totalOptions * MENU_ITEM_HEIGHT + MENU_PADDING_Y * 2;
  const language = getLang();
  const showPreferredLangToggle = useMemo(() => /*#__PURE__*/_jsx(View, {
    maxInlineSize: "200px",
    children: /*#__PURE__*/_jsx(Checkbox, {
      checked: showPreferredLanguageFirst,
      marginBlockStart: "100",
      onChange: ({
        target: {
          checked
        }
      }) => {
        if (onShowPreferredLanguageFirstChange) {
          onShowPreferredLanguageFirstChange(checked);
        }
      },
      size: "small",
      children: /*#__PURE__*/_jsx(Text, {
        marginBlockStart: "-100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'marketplace-ui-apps-core.results.sort.showPreferredLangFirst',
          options: {
            language: unescapedText(`SharedI18nStrings.languageNames.${language}`)
          }
        })
      })
    })
  }), [language, onShowPreferredLanguageFirstChange, showPreferredLanguageFirst]);
  return /*#__PURE__*/_jsx(InlineLabel, {
    marginBlockStart: "0",
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'marketplace-ui-apps-core.results.sort.label'
    }),
    children: /*#__PURE__*/_jsx(Select, {
      "data-test-id": "apps-sort-dropdown",
      buttonUse: "transparent",
      disabled: disabled,
      dropdownFooter: onShowPreferredLanguageFirstChange ? showPreferredLangToggle : null,
      itemComponent: SortSelectItem,
      menuHeight: minHeight,
      menuWidth: "auto",
      onChange: handleChange,
      options: options,
      value: value
    })
  });
}